export default "<app-taximap (moveEnd)=\"moveEnd($event)\" #map>\r\n</app-taximap>\r\n";